ko.components.register('domain-alerts', {
	viewModel: function(params) {
		var self = this;

		self.element = false;
		self.tip = false;
		self.showDetails = ko.observable(false);

		self.id = ko.observable(params.id);
		self.name = ko.observable(params.name);

		// pending tasks list
		self.crawl_tasks = ko.observableArray();

		// counters
		self.crawl_errors_count = ko.observable();

		self.iframe_count = ko.observable();
		self.script_count = ko.observable();
		self.links_count = ko.observable();

		// links
		self.links_int_30x_count = ko.observable();
		self.links_int_40x_count = ko.observable();
		self.links_int_50x_count = ko.observable();
		self.links_ext_30x_count = ko.observable();
		self.links_ext_40x_count = ko.observable();
		self.links_ext_50x_count = ko.observable();

		// flags
		self.has_30x_errors = ko.observable();
		self.has_40x_errors = ko.observable();
		self.has_50x_errors = ko.observable();
		self.has_new_iframe = ko.observable();
		self.has_new_script = ko.observable();
		self.has_new_link = ko.observable();
		self.malware_detected = ko.observable();

		// ignore
		self.ignore_30x_errors = ko.observable();
		self.ignore_40x_errors = ko.observable();
		self.ignore_50x_errors = ko.observable();
		self.ignore_new_iframe = ko.observable();
		self.ignore_new_script = ko.observable();
		self.ignore_new_link = ko.observable();
		self.ignore_malware_detected = ko.observable();

		// dates
		self.last_crawl_date = ko.observable();
        // extra dates
		self.last_check_date = ko.observable();
        self.last_parse_date = ko.observable();
        self.last_files_scan_date = ko.observable();

		// ajax

		self.loading = ko.observable(false);

		self.ajaxRequest = function(action, params, callback) {
			if(self.loading())
				return;
			self.loading(true);
			return App.ajaxRequest('crawl/' + action, params).done(function(r) {
				callback && callback(r);
			}).always(function() {
				self.loading(false);
			});
		};

		self.setData = function(data) {
			self.crawl_tasks((data && data.crawl_tasks) || []);

			// counters
			self.crawl_errors_count(parseInt(data && data.crawl_errors_count || 0));

			self.iframe_count(parseInt(data && data.iframe_count || 0));
			self.script_count(parseInt(data && data.script_count || 0));
			self.links_count(parseInt(data && data.links_count || 0));

			// links
			self.links_int_30x_count(parseInt(data && data.links_int_30x_count || 0));
			self.links_int_40x_count(parseInt(data && data.links_int_40x_count || 0));
			self.links_int_50x_count(parseInt(data && data.links_int_50x_count || 0));
			self.links_ext_30x_count(parseInt(data && data.links_ext_30x_count || 0));
			self.links_ext_40x_count(parseInt(data && data.links_ext_40x_count || 0));
			self.links_ext_50x_count(parseInt(data && data.links_ext_50x_count || 0));

			// flags
			self.has_30x_errors(parseInt(data && data.has_30x_errors || 0));
			self.has_40x_errors(parseInt(data && data.has_40x_errors || 0));
			self.has_50x_errors(parseInt(data && data.has_50x_errors || 0));
			self.has_new_iframe(parseInt(data && data.has_new_iframe || 0));
			self.has_new_script(parseInt(data && data.has_new_script || 0));
			self.has_new_link(parseInt(data && data.has_new_link || 0));
			self.malware_detected(parseInt(data && data.malware_detected || 0));

			// ignore
			self.ignore_30x_errors(parseInt(data && data.has_30x_errors || 0) === -1);
			self.ignore_40x_errors(parseInt(data && data.has_40x_errors || 0) === -1);
			self.ignore_50x_errors(parseInt(data && data.has_50x_errors || 0) === -1);
			self.ignore_new_iframe(parseInt(data && data.has_new_iframe || 0) === -1);
			self.ignore_new_script(parseInt(data && data.has_new_script || 0) === -1);
			self.ignore_new_link(parseInt(data && data.has_new_link || 0) === -1);
			self.ignore_malware_detected(parseInt(data && data.malware_detected || 0) === -1);

			// dates
			self.last_crawl_date((data && data.last_crawl_date) || false);

			// extra dates
			self.last_check_date((data && data.last_check_date) || false);
            self.last_parse_date((data && data.last_parse_date) || false);
            self.last_files_scan_date((data && data.last_files_scan_date) || false);
		};

		// methods

		self.getActionUrl = function(action) {
			return App.urls.base + '/domain/' + self.id() + '/crawl/' + action;
		};

		self.getInternalLinksUrl = function() {
			return self.getActionUrl('internal');
		};

		self.getExtermalLinksUrl = function() {
			return self.getActionUrl('external');
		};

		self.getTagsUrl = function() {
			return self.getActionUrl('tags');
		};

		self.getMalwareUrl = function() {
			return self.getActionUrl('malware');
		};

		self.getLinksTagsUrl = function() {
			return self.getTagsUrl() + "?DomainHtmlTag%5Bname%5D=A" + (self.has_new_link() ? "&DomainHtmlTag%5Bis_new%5D=1" : "");
		};

		self.getIframeTagsUrl = function() {
			return self.getTagsUrl() + "?DomainHtmlTag%5Bname%5D=IFRAME" + (self.has_new_iframe() ? "&DomainHtmlTag%5Bis_new%5D=1" : "");
		};

		self.getScriptTagsUrl = function() {
			return self.getTagsUrl() + "?DomainHtmlTag%5Bname%5D=SCRIPT" + (self.has_new_script() ? "&DomainHtmlTag%5Bis_new%5D=1" : "");
		};

		self.hasExtLinksErrors = ko.pureComputed(function() {
			return self.links_ext_30x_count() || self.links_ext_40x_count() || self.links_ext_50x_count();
		});

		self.hasIntLinksErrors = ko.pureComputed(function() {
			return self.links_int_30x_count() || self.links_int_40x_count() || self.links_int_50x_count();
		});

		self.getLabelCss = ko.pureComputed(function() {
			var c = [];
			if(self.crawl_errors_count() === 0) {
				var tasksCount = self.crawl_tasks().length;
				if(tasksCount > 0)
					c.push('no-errors badge badge-pill badge-success');
				else
					c.push('no-errors text-success');
			} else {
				if(self.malware_detected())
					c.push('has-errors badge badge-pill badge-danger');
				else
					c.push('has-errors badge badge-pill badge-warning');
			}
			if(self.showDetails())
				c.push('active');
			return c.join(' ');
		});

		self.getLabel = ko.pureComputed(function() {
			if(self.crawl_errors_count() === 0) {
				var tasksCount = self.crawl_tasks().length;
				if(tasksCount > 0)
					return tasksCount;
				return '<span class="ic ic-ok"></span>';
			}
			return self.crawl_errors_count();
		});

		self.update = function() {
			var params = {
				id: self.id(),
				links_int_30x_count: self.links_int_30x_count(),
				links_int_40x_count: self.links_int_40x_count(),
				links_int_50x_count: self.links_int_50x_count(),
				links_ext_30x_count: self.links_ext_30x_count(),
				links_ext_40x_count: self.links_ext_40x_count(),
				links_ext_50x_count: self.links_ext_50x_count(),
				has_30x_errors: self.ignore_30x_errors(),
				has_40x_errors: self.ignore_40x_errors(),
				has_50x_errors: self.ignore_50x_errors(),
				has_new_iframe: self.ignore_new_iframe(),
				has_new_script: self.ignore_new_script(),
				has_new_link: self.ignore_new_link()
			};
			// merge with ignores
			if(self.ignore_30x_errors())
				params['has_30x_errors'] = -1;
			if(self.ignore_40x_errors())
				params['has_40x_errors'] = -1;
			if(self.ignore_50x_errors())
				params['has_50x_errors'] = -1;
			if(self.ignore_new_iframe())
				params['has_new_iframe'] = -1;
			if(self.ignore_new_script())
				params['has_new_script'] = -1;
			if(self.ignore_new_link())
				params['has_new_link'] = -1;
			if(self.ignore_malware_detected())
				params['malware_detected'] = -1;

			// send update request
			return self.ajaxRequest('update', params, function(r) {
				if(r.data) self.setData(r.data);
			});
		};

		self.resetInt30x = function() {
			self.links_int_30x_count(0);
			self.update();
		};
		self.resetInt40x = function() {
			self.links_int_40x_count(0);
			self.update();
		};
		self.resetInt50x = function() {
			self.links_int_50x_count(0);
			self.update();
		};
		self.resetExt30x = function() {
			self.links_ext_30x_count(0);
			self.update();
		};
		self.resetExt40x = function() {
			self.links_ext_40x_count(0);
			self.update();
		};
		self.resetExt50x = function() {
			self.links_ext_50x_count(0);
			self.update();
		};
		self.resetAll = function() {
			return self.ajaxRequest('reset', {id: self.id()}, function(r) {
				if(r.data) self.setData(r.data);
			});
		};

		self.toggleDetails = function(data, event) {
			self.showDetails(!self.showDetails());

			if(!self.showDetails()) {
				self.tip
					.stop()
					.animate({left: '15px', opacity: 0}, 200, function() {
						self.element.removeClass('active');
						self.element.popover('hide');
						self.tip.css({left: -1000});
					});
			} else {
				if(!self.element)
					self.element = $(event.target);
				if(!self.element.data('bs.popover')) {
					var $details = $('#domain-alerts-details-' + self.id());
					self.element.popover({
						animation: false,
						placement: 'left',
						html: true,
						content: $details
					});
					$details.show();
					self.tip = $(self.element.data('bs.popover').getTipElement());
				}

				self.element.addClass('active');
				self.element.popover('show');

				self.tip
					.stop()
					.css({left: '15px', opacity: 0})
					.animate({left: 0, opacity: 1}, 200);
			}
		};

		self.setData(params.data || {});

		self.ignore_30x_errors.subscribe(self.update);
		self.ignore_40x_errors.subscribe(self.update);
		self.ignore_50x_errors.subscribe(self.update);
		self.ignore_new_iframe.subscribe(self.update);
		self.ignore_new_script.subscribe(self.update);
		self.ignore_new_link.subscribe(self.update);
		self.ignore_malware_detected.subscribe(self.update);
	},
	template: "<div class=\"cursor-pointer domain-alerts\" data-bind=\"\n\tattr: { 'id': 'domain-alerts-' + id()},\n\tcss: getLabelCss(),\n\thtml: getLabel,\n\tevent: { click: toggleDetails }\n\"></div>\n<div style=\"display:none\" type=\"text/html\" data-bind=\"attr: { 'id': 'domain-alerts-details-' + id()}\">\n\t<div class=\"domain-alerts-details\" data-bind=\"css: { 'loading': loading() }\">\n\t\t<small class=\"spinner spinner-border spinner-primary\" data-bind=\"visible: loading()\"></small>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col mb-2\">\n\t\t\t\t<button class=\"close clearfix\" data-bind=\"attr: {'data-parent': '#domain-alerts-' + id()}, click: toggleDetails\">&times;</button>\n\t\t\t\t<h5 class=\"domain-alerts-header\">\n\t\t\t\t\t<span data-bind=\"text: name()\"></span>\n\t\t\t\t\t<small class=\"text-muted\">Crawl Details</small>\n\t\t\t\t</h5>\n\t\t\t\t<a target=\"_blank\" class=\"btn btn-danger btn-block btn-sm mt-2\" data-bind=\"visible: malware_detected(), attr: {'href': getMalwareUrl()}\">Malware Detected</a>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"domain-alerts-body\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col\">\n\t\t\t\t\t<table class=\"table table-bordered table-striped table-sm mb-0\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th><a data-bind=\"attr: {href: getIframeTagsUrl()}\" target=\"_blank\"><strong>&lt;IFRAME&gt;</strong></a></th>\n\t\t\t\t\t\t<td class=\"px-2\" data-bind=\"text: iframe_count(), css: {'text-danger': has_new_iframe() > 0}\"></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th><a data-bind=\"attr: {href: getScriptTagsUrl()}\" target=\"_blank\"><strong>&lt;SCRIPT&gt;</strong></a></th>\n\t\t\t\t\t\t<td class=\"px-2\" data-bind=\"text: script_count(), css: {'text-danger': has_new_script() > 0}\"></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class=\"text-nowrap\"><a data-bind=\"attr: {href: getLinksTagsUrl()}\" target=\"_blank\"><strong>&lt;A&gt;</strong></a></th>\n\t\t\t\t\t\t<td class=\"px-2\" data-bind=\"text: links_count(), css: {'text-danger': has_new_link() > 0}\"></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t</table>\n\n\t\t\t\t\t<div class=\"ignore-events\">\n\t\t\t\t\t\t<h5 class=\"my-2\">Ignore Events</h5>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_30x_errors\" /> 30x</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_40x_errors\" /> 40x</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_50x_errors\" /> 50x</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_new_iframe\" /> +IFRAME</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_new_script\" /> +SCRIPT</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_new_link\" /> +LINK</label>\n\t\t\t\t\t\t<label class=\"btn btn-light btn-sm mb-1\"><input type=\"checkbox\" data-bind=\"checked: ignore_malware_detected\" /> MALWARE</label>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<button class=\"btn btn-outline-danger btn-sm\" data-bind=\"click: $component.resetAll\">Confirm ALL</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col\" data-bind=\"visible: hasIntLinksErrors() || hasExtLinksErrors()\">\n\t\t\t\t\t<h5 class=\"text-nowrap text-danger\">HTTP Errors</h5>\n\t\t\t\t\t<div data-bind=\"visible: hasIntLinksErrors\">\n\t\t\t\t\t\t<a data-bind=\"attr: {href: getInternalLinksUrl()}\" target=\"_blank\"><strong class=\"text-danger\">Internal Links</strong></a>\n\t\t\t\t\t\t<table class=\"table table-bordered table-sm mb-1\">\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th scope=\"col\">30x <a class=\"reset\" data-bind=\"visible: links_int_30x_count(), click: $component.resetInt30x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t\t<th scope=\"col\">40x <a class=\"reset\" data-bind=\"visible: links_int_40x_count(), click: $component.resetInt40x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t\t<th scope=\"col\">50x <a class=\"reset\" data-bind=\"visible: links_int_50x_count(), click: $component.resetInt50x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_int_30x_count() ? links_int_30x_count() : ''\"></td>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_int_40x_count() ? links_int_40x_count() : ''\"></td>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_int_50x_count() ? links_int_50x_count() : ''\"></td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div data-bind=\"visible: hasExtLinksErrors\">\n\t\t\t\t\t\t<a data-bind=\"attr: {href: getExtermalLinksUrl()}\" target=\"_blank\"><strong class=\"text-danger\">External Links</strong></a>\n\t\t\t\t\t\t<table class=\"table table-bordered table-sm mb-0\">\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th scope=\"col\">30x <a class=\"reset\" data-bind=\"visible: links_ext_30x_count(), click: $component.resetExt30x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t\t<th scope=\"col\">40x <a class=\"reset\" data-bind=\"visible: links_ext_40x_count(), click: $component.resetExt40x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t\t<th scope=\"col\">50x <a class=\"reset\" data-bind=\"visible: links_ext_50x_count(), click: $component.resetExt50x\" title=\"Reset\">&times;</a></th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_ext_30x_count() ? links_ext_30x_count() : ''\"></td>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_ext_40x_count() ? links_ext_40x_count() : ''\"></td>\n\t\t\t\t\t\t\t<td data-bind=\"text: links_ext_50x_count() ? links_ext_50x_count() : ''\"></td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"mt-2 text-muted\">\n\t\t\t\t<div class=\"mb-1\" data-bind=\"visible: crawl_tasks().length > 0\">Pending Tasks: <strong class=\"badge badge-pill badge-success\" data-bind=\"text: crawl_tasks().length\"></strong></div>\n\t\t\t\t<div data-bind=\"visible: last_crawl_date()\">Last crawl: <strong data-bind=\"text: last_crawl_date\"></strong></div>\n\t\t\t\t<div data-bind=\"visible: last_parse_date()\">SEO updated: <strong data-bind=\"text: last_parse_date\"></strong></div>\n\t\t\t\t<div data-bind=\"visible: last_check_date()\">Whois/SSL: <strong data-bind=\"text: last_check_date\"></strong></div>\n\t\t\t\t<div data-bind=\"visible: last_files_scan_date()\">Files Scan: <strong data-bind=\"text: last_files_scan_date\"></strong></div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
});